export default __webpack_public_path__ + "0bd79218086b3dbc23c9fdde6a4548a0.jpg";